var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { LinkButton } from '../../common/components/Link';
import { display, fontSize, position, right, themeGet } from 'styled-system';
import { themeBottom, themeTop } from '../../common/theme/theme';
var LegalNotesLinkContainer = styled(LinkButton)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n\n  /* The !important is because of Shop-Reboot :'( */\n  color: ", " !important;\n  text-decoration: underline !important;\n  cursor: pointer;\n\n  &:before {\n    content: '*';\n    padding-right: 5px;\n    ", ";\n  }\n\n  &:hover {\n    color: ", " !important;\n  }\n"], ["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n\n  /* The !important is because of Shop-Reboot :'( */\n  color: ", " !important;\n  text-decoration: underline !important;\n  cursor: pointer;\n\n  &:before {\n    content: '*';\n    padding-right: 5px;\n    ", ";\n  }\n\n  &:hover {\n    color: ", " !important;\n  }\n"])), right, fontSize, position, function (_a) {
    var alignBottom = _a.alignBottom;
    return (alignBottom ? themeBottom : themeTop);
}, function (props) { return props.linkLabelColor; }, display, themeGet('colors.brand.normal'));
LegalNotesLinkContainer.defaultProps = {
    as: 'span',
    fontSize: 3,
    right: '12px',
    themeTop: 2,
    themeBottom: 2,
    position: 'absolute',
    display: 'inline-block',
};
var LegalNotesLink = function (_a) {
    var linkLabel = _a.linkLabel, linkLabelColor = _a.linkLabelColor, onClick = _a.onClick, alignBottom = _a.alignBottom;
    return (React.createElement(LegalNotesLinkContainer, { alignBottom: alignBottom, linkLabelColor: linkLabelColor, onClick: onClick }, linkLabel));
};
LegalNotesLink.propTypes = {
    linkLabel: PropTypes.string.isRequired,
    linkLabelColor: PropTypes.string.isRequired,
    alignBottom: PropTypes.bool,
    onClick: PropTypes.func,
};
LegalNotesLink.defaultProps = {
    onClick: function () { return undefined; },
};
export default LegalNotesLink;
var templateObject_1;
